export default __webpack_public_path__ + "static/media/slide3.ef85c955.jpg";